export const environment = {
  defaultUnprotectedRoute: '/',
  defaultProtectedRoute: '/main',
  zustandStoreVersion: 3,
  config: {
    enableCoins: true,
    firebasePubKey: 'BGT88GnB1G993KM6PRzEz33q7PBQrkSQyUxDOa5hbk5KfdrTQ8jHIOQMpWl9tbAIYsqS0ELDbTqsY84szQGUeZQ',
  },
  firebase: {
    apiKey: 'AIzaSyC9wP1esGaywTEhORQT4aMwR-UMZLDXGb4',
    authDomain: 'experiencedays-80fbf.firebaseapp.com',
    projectId: 'experiencedays-80fbf',
    storageBucket: 'experiencedays-80fbf.appspot.com',
    messagingSenderId: '187785716513',
    appId: '1:187785716513:web:cd97681d3ef8c147bd1460',
    measurementId: 'G-0LSXPRZF3K',
  },
  api: {
    baseUrl: process.env.REACT_APP_BASE_URL || 'https://api-dev.neles.ligafacens.com',
    auth: {
      local: '/auth/{authType}',
    },
    user: {
      me: '/users/me?join[0]=trackProgress',
      create: '/users',
      selectClass: '/users/{userId}/class-type',
      update: '/users/{userId}',
      ranking: '/users/{userId}/ranking',
      listRanking: '/users/ranking?page={page}&limit={limit}',
      forgotEmail: '/users/password/forgot/email/{email}',
      resetPassword: '/users/password/reset/{code}',
    },
    quizes: {
      list: '/quizes?join=place&join[0]=questions&join[1]=questions.answers&limit=1000',
      sendAnswer: '/users/questions/{questionId}/answers',
    },
    lives: {
      list: '/lives?limit=1000',
      featured: '/lives/featured',
      get: '/lives/{liveId}',
      listByType: '/lives/{type}?page={page}&limit={limit}',
      watched: '/users/{userId}/lives/{liveId}/watched',
    },
    tracks: {
      list: '/tracks?s={searchParams}&limit=1000&join[0]=quizes&join[1]=quizes.questions&join[2]=quizes.questions.answers&sort=name,ASC',
      saveProgress: '/users/{userId}/tracks/{trackId}/progress',
    },
    certificates: {
      get: '/users/{userId}/tracks/{trackId}/certificates',
    },
    places: {
      list: '/places?s={searchParams}&limit=1000',
    },
    notifications: {
      list: '/notification?page={page}&limit={limit}&s={searchParams}&sort={sort}',
    },
    feedbacks: {
      list: '/users/feedbacks?s={searchParams}&limit=1',
      create: '/users/feedbacks',
    },
  },
};
